/**
 * Estilo "brutalista" de card (CLAUDE.md #108): container sem borda + sombra
 * rígida 90° para baixo (offset vertical, sem horizontal — não é um box-shadow
 * de elevação comum). Cards internos/aninhados usam a variante tracejada, sem
 * sombra.
 *
 * Antes desta fonte única, a MESMA string vivia repetida literalmente em 7+
 * lugares (`QuoteForm.tsx` x5, `GeneralPhotosSection.tsx` x2) + 2 variantes de
 * cor em `NewQuotePage.tsx` (header azul, rodapé âmbar) — uma correção futura
 * na sombra facilmente esqueceria um dos pontos.
 *
 * São CONSTANTES LITERAIS de propósito, uma por cor — não uma função que monta
 * a classe por interpolação. O Tailwind JIT só reconhece uma classe de valor
 * arbitrário (`shadow-[...]`) se ela aparecer como STRING COMPLETA em algum
 * arquivo varrido; construí-la em runtime a partir de partes (`shadow-[...${x}]`)
 * a esconderia do scanner e a sombra simplesmente não apareceria no build.
 */
export const BRUTALIST_CARD_CLASS =
  'border-0 shadow-[0px_8px_0px_0px_hsla(var(--primary)/0.35)] rounded-md bg-gradient-to-r from-primary/5 to-primary/10 text-card-foreground';

/** Header do formulário (nº do orçamento). */
export const BRUTALIST_CARD_CLASS_BLUE =
  'border-0 bg-gradient-to-r from-[#2f6fae]/5 to-[#2f6fae]/10 shadow-[0px_8px_0px_0px_rgba(47,111,174,0.35)] rounded-md';

/** Rodapé de ações (Baixar PDF / Salvar). */
export const BRUTALIST_CARD_CLASS_AMBER =
  'border-0 bg-gradient-to-r from-amber-500/5 to-amber-500/10 shadow-[0px_8px_0px_0px_rgba(245,158,11,0.35)] rounded-md';

/** Card interno/aninhado (ex.: item dentro do card de Itens). */
export const BRUTALIST_CHILD_CARD_CLASS =
  'border-[3px] border-dashed border-primary/50 shadow-none rounded-md bg-white dark:bg-card text-card-foreground';
